import { Level } from 'angular2-logger/core';

export const environment = {
  production: true,
  HTTP_BASE_URL : '/mdm',
  logger : {
    level : Level.OFF
  },
  kyungnamIsTrue : false,
  nambuIsTrue : false,
  dtaqIsTrue : false,         //국방기술품질원    // 긴급해제 정책 로그 히든처리 true-사용 false- 미사용
  shIsTrue : false,             // SH공사          // 인사연동현황-사용
  acuonIsTrue : false,            // 애큐온캐피탈   // 인사연동현황-사용
  visitorLocationIsTrue : false,  // 국방기술품질원  // 방문자 위치정보 확인 사용 - true, 미사용 - false
  visitorInfoModifyIsTrue : false, // 기본 false  // 방문자 정보 수정(장기/단기방문자 구분) 기능 사용 - true, 미사용 - false
  officeVersionShow : false,   //업무앱 버전 보여주는기능     // true 메뉴 보임 false 메뉴 히든
  inOutShow : false    //출입정책 inOut 현황 보여주는 기능 // true 보임 false 히든처리
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts